import { UserWithGroup } from '@app/core/types/users';
import { UserActionPermissionsView } from '@app/modules/admin/components/actions-permissions/UserActionPermissionsView';
import { UserRole } from '@mi-front/core';
import { UserInfo } from './tabs/UserInfo';
import { UserPermissionsManager } from './tabs/UserPermissionsManager';
import { TabKey, useAdminUsersViewTabs } from './useAdminUsersViewTabs';

interface Props {
  readonly user: UserWithGroup;
}

/**
 * Renders the active user-view tab panel based on the `?tab=` query param.
 */
export function AdminUsersViewTabContent({ user }: Props) {
  const { activeTab } = useAdminUsersViewTabs(user);

  return (
    <>
      {activeTab === TabKey.INFO && <UserInfo user={user} canEdit />}
      {activeTab === TabKey.PERMISSIONS && <UserPermissionsManager user={user} />}
      {activeTab === TabKey.ACTIONS_PERMISSIONS && user.role === UserRole.CLIENT_USER && (
        <UserActionPermissionsView user={user} />
      )}
    </>
  );
}
